import React from "react";

export default function Footer({ fixed }) {
    return (
        <div className=" text-center p-5 text-sm leading-8">
            <p className="">Malaysia Web Developer • Freelance Website • WordPress Service • Security & Speed Optimization Website • Custom Website • E-commerce Website </p>
            <p>Designed by <span className="text-primary font-semibold">Naja Nadhirah -Professional Web Developer (Malaysia)</span></p>
        </div>
    );
}